<base-node [node]="node">
    <div>
        <mat-icon svgIcon="netra-icon" class="netra-icon" [routerLinkActive]="['matlist-icon-active']">
        </mat-icon>
        <h6>{{node.device.name}}</h6>
        <div class="flex-row center mt-20">
            <div class="flex-row button-container">
                <button mat-icon-button class="hover-button" (click)="openChartNode(node)">
                    <mat-icon svgIcon="psd-white"></mat-icon>
                </button>
                <!-- To Be Implemented -->
                <!-- <button mat-icon-button class="hover-button" [ngClass]="{ 'threshold-true': node.threshold }"
                    matTooltip="Threshold Alert" [matTooltipPosition]="'right'">
                    <mat-icon>add_alert</mat-icon>
                </button> -->
            </div>
        </div>
    </div>
</base-node>